import {DateTime} from "luxon";
import {UuidHelper} from "../helpers/uuid.helper";
import {CommandName} from "./command-name.enum";
import {ICommand} from "./i-command.interface";

/**
 * Several commands in one request, run inside ONE transaction on the server.
 *
 * The type parameter is deliberately UNCONSTRAINED. It used to read
 * `<T extends Entity<T>>`, which no longer holds: a Linkview save carries
 * sub-commands whose payloads are plain objects — `LinkTile` is deliberately not
 * an `Entity<T>`, since that whole machinery assumes change-tracked proxies. The
 * constraint expressed nothing at runtime (types are erased and every payload
 * reaches the wire through its own transformer), so it only ruled out a
 * legitimate use. Worth stating because this build has no type-check gate: the
 * violation would have been invisible rather than loud.
 */
export class BulkCommand<T = any> implements ICommand<ICommand<T>[]> {

    public uid: string = UuidHelper.generateV7();

    public name: CommandName = CommandName.BULK;

    public dateTime: DateTime = DateTime.now();

    public payload: ICommand<T>[];

    public tags = ['entity', 'bulk'];

    public readonly mainEntityClass: string = "bulk";

    public readonly mainEntityUid: string = "bulk";

    public constructor(commands: ICommand<T>[]) {
        this.payload = commands;
    }
}